import copy from '../../demo/fixtures/w5/copy.json'
import rules from '../../demo/fixtures/w5/rules.json'
import { Card, Icon } from '../../ui'
import styles from './AutomationPage.module.css'

export function GuardChips() {
  return (
    <Card padded className={`${styles.section} ${styles.guardsCard}`} data-scope="guards" lang="zh-CN">
      <div className={styles.sectionHeading}>
        <p>{copy.sections.guards}</p>
        <span>{copy.sections.guardsHint}</span>
      </div>
      <div className={styles.guards}>
        {rules.guards.map((guard) => (
          <span className={styles.guard} key={guard}>
            <Icon name="shield" size={14} />
            {guard}
          </span>
        ))}
      </div>
    </Card>
  )
}
